// extracted by mini-css-extract-plugin
export default {"hero":"GuestLogin_hero__1VTRy","heroIcon":"GuestLogin_heroIcon__81FwW","heroTitle":"GuestLogin_heroTitle__W3pLE","heroSub":"GuestLogin_heroSub__8SQ9W"};